import { put, takeLatest, call } from "redux-saga/effects";
import Api from "./api";
import {
  ENG_SEGMENT_LIST_ACTION, ENG_SEGMENT_LIST_LOADING, ENG_SEGMENT_LIST_SUCCESS, ENG_SEGMENT_LIST_ERROR,
  ENG_SEGMENT_CREATE_ACTION, ENG_SEGMENT_CREATE_LOADING, ENG_SEGMENT_CREATE_SUCCESS, ENG_SEGMENT_CREATE_ERROR,
  ENG_SEGMENT_PREVIEW_ACTION, ENG_SEGMENT_PREVIEW_LOADING, ENG_SEGMENT_PREVIEW_SUCCESS, ENG_SEGMENT_PREVIEW_ERROR,
  ENG_TEMPLATE_LIST_ACTION, ENG_TEMPLATE_LIST_LOADING, ENG_TEMPLATE_LIST_SUCCESS, ENG_TEMPLATE_LIST_ERROR,
  ENG_CAMPAIGN_LIST_ACTION, ENG_CAMPAIGN_LIST_LOADING, ENG_CAMPAIGN_LIST_SUCCESS, ENG_CAMPAIGN_LIST_ERROR,
  ENG_CAMPAIGN_CREATE_ACTION, ENG_CAMPAIGN_CREATE_LOADING, ENG_CAMPAIGN_CREATE_SUCCESS, ENG_CAMPAIGN_CREATE_ERROR,
  ENG_CAMPAIGN_LAUNCH_ACTION, ENG_CAMPAIGN_LAUNCH_LOADING, ENG_CAMPAIGN_LAUNCH_SUCCESS, ENG_CAMPAIGN_LAUNCH_ERROR,
  ENG_CAMPAIGN_PAUSE_ACTION, ENG_CAMPAIGN_PAUSE_LOADING, ENG_CAMPAIGN_PAUSE_SUCCESS, ENG_CAMPAIGN_PAUSE_ERROR,
  ENG_CAMPAIGN_CANCEL_ACTION, ENG_CAMPAIGN_CANCEL_LOADING, ENG_CAMPAIGN_CANCEL_SUCCESS, ENG_CAMPAIGN_CANCEL_ERROR,
  ENG_CAMPAIGN_ANALYTICS_ACTION, ENG_CAMPAIGN_ANALYTICS_LOADING, ENG_CAMPAIGN_ANALYTICS_SUCCESS, ENG_CAMPAIGN_ANALYTICS_ERROR,
} from "./types";

function* segmentListSaga({ payload }) {
  yield put({ type: ENG_SEGMENT_LIST_LOADING });
  try {
    const res = yield call(Api.listSegments, payload);
    if (res?.message) yield put({ type: ENG_SEGMENT_LIST_ERROR, payload: res.message });
    else yield put({ type: ENG_SEGMENT_LIST_SUCCESS, payload: res });
  } catch (e) {
    yield put({ type: ENG_SEGMENT_LIST_ERROR, payload: e.message });
  }
}

function* segmentCreateSaga({ payload }) {
  yield put({ type: ENG_SEGMENT_CREATE_LOADING });
  try {
    const res = yield call(Api.createSegment, payload);
    if (res?.message) yield put({ type: ENG_SEGMENT_CREATE_ERROR, payload: res.message });
    else yield put({ type: ENG_SEGMENT_CREATE_SUCCESS, payload: res });
  } catch (e) {
    yield put({ type: ENG_SEGMENT_CREATE_ERROR, payload: e.message });
  }
}

function* segmentPreviewSaga({ payload }) {
  yield put({ type: ENG_SEGMENT_PREVIEW_LOADING });
  try {
    const res = yield call(Api.previewSegment, payload);
    if (res?.message) yield put({ type: ENG_SEGMENT_PREVIEW_ERROR, payload: res.message });
    else yield put({ type: ENG_SEGMENT_PREVIEW_SUCCESS, payload: res });
  } catch (e) {
    yield put({ type: ENG_SEGMENT_PREVIEW_ERROR, payload: e.message });
  }
}

function* templateListSaga({ payload }) {
  yield put({ type: ENG_TEMPLATE_LIST_LOADING });
  try {
    const res = yield call(Api.listTemplates, payload);
    if (res?.message) yield put({ type: ENG_TEMPLATE_LIST_ERROR, payload: res.message });
    else yield put({ type: ENG_TEMPLATE_LIST_SUCCESS, payload: res });
  } catch (e) {
    yield put({ type: ENG_TEMPLATE_LIST_ERROR, payload: e.message });
  }
}

function* campaignListSaga({ payload }) {
  yield put({ type: ENG_CAMPAIGN_LIST_LOADING });
  try {
    const res = yield call(Api.listCampaigns, payload);
    if (res?.message) yield put({ type: ENG_CAMPAIGN_LIST_ERROR, payload: res.message });
    else yield put({ type: ENG_CAMPAIGN_LIST_SUCCESS, payload: res });
  } catch (e) {
    yield put({ type: ENG_CAMPAIGN_LIST_ERROR, payload: e.message });
  }
}

function* campaignCreateSaga({ payload }) {
  yield put({ type: ENG_CAMPAIGN_CREATE_LOADING });
  try {
    const res = yield call(Api.createCampaign, payload);
    if (res?.message) yield put({ type: ENG_CAMPAIGN_CREATE_ERROR, payload: res.message });
    else yield put({ type: ENG_CAMPAIGN_CREATE_SUCCESS, payload: res });
  } catch (e) {
    yield put({ type: ENG_CAMPAIGN_CREATE_ERROR, payload: e.message });
  }
}

function* campaignLaunchSaga({ payload }) {
  yield put({ type: ENG_CAMPAIGN_LAUNCH_LOADING });
  try {
    const res = yield call(Api.launchCampaign, payload);
    if (res?.message) yield put({ type: ENG_CAMPAIGN_LAUNCH_ERROR, payload: res.message });
    else yield put({ type: ENG_CAMPAIGN_LAUNCH_SUCCESS, payload: res });
  } catch (e) {
    yield put({ type: ENG_CAMPAIGN_LAUNCH_ERROR, payload: e.message });
  }
}

function* campaignPauseSaga({ payload }) {
  yield put({ type: ENG_CAMPAIGN_PAUSE_LOADING });
  try {
    const res = yield call(Api.pauseCampaign, payload);
    if (res?.message) yield put({ type: ENG_CAMPAIGN_PAUSE_ERROR, payload: res.message });
    else yield put({ type: ENG_CAMPAIGN_PAUSE_SUCCESS, payload: res });
  } catch (e) {
    yield put({ type: ENG_CAMPAIGN_PAUSE_ERROR, payload: e.message });
  }
}

function* campaignCancelSaga({ payload }) {
  yield put({ type: ENG_CAMPAIGN_CANCEL_LOADING });
  try {
    const res = yield call(Api.cancelCampaign, payload);
    if (res?.message) yield put({ type: ENG_CAMPAIGN_CANCEL_ERROR, payload: res.message });
    else yield put({ type: ENG_CAMPAIGN_CANCEL_SUCCESS, payload: res });
  } catch (e) {
    yield put({ type: ENG_CAMPAIGN_CANCEL_ERROR, payload: e.message });
  }
}

function* campaignAnalyticsSaga({ payload }) {
  yield put({ type: ENG_CAMPAIGN_ANALYTICS_LOADING });
  try {
    const res = yield call(Api.getCampaignAnalytics, payload);
    if (res?.message) yield put({ type: ENG_CAMPAIGN_ANALYTICS_ERROR, payload: res.message });
    else yield put({ type: ENG_CAMPAIGN_ANALYTICS_SUCCESS, payload: res });
  } catch (e) {
    yield put({ type: ENG_CAMPAIGN_ANALYTICS_ERROR, payload: e.message });
  }
}

export default function* watchEngagementAsync() {
  yield takeLatest(ENG_SEGMENT_LIST_ACTION, segmentListSaga);
  yield takeLatest(ENG_SEGMENT_CREATE_ACTION, segmentCreateSaga);
  yield takeLatest(ENG_SEGMENT_PREVIEW_ACTION, segmentPreviewSaga);
  yield takeLatest(ENG_TEMPLATE_LIST_ACTION, templateListSaga);
  yield takeLatest(ENG_CAMPAIGN_LIST_ACTION, campaignListSaga);
  yield takeLatest(ENG_CAMPAIGN_CREATE_ACTION, campaignCreateSaga);
  yield takeLatest(ENG_CAMPAIGN_LAUNCH_ACTION, campaignLaunchSaga);
  yield takeLatest(ENG_CAMPAIGN_PAUSE_ACTION, campaignPauseSaga);
  yield takeLatest(ENG_CAMPAIGN_CANCEL_ACTION, campaignCancelSaga);
  yield takeLatest(ENG_CAMPAIGN_ANALYTICS_ACTION, campaignAnalyticsSaga);
}
